/**
 *   Generated file. Do not edit
 */

import { CloudPlatform } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getPlatform: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/platform',
    path: '/1024//26',
    responseBodyDecoder: allConverters.cloudPlatform,
  } as ServiceCallType<void, CloudPlatform>,

  putPlatform: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/platform',
    path: '/1024//26',
    bodyEncoder: allConverters.cloudPlatform,
  } as ServiceCallType<CloudPlatform, void>,

  getDataLogUploadPeriod: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/data-log/upload-period',
    path: '/1024//33',
    responseBodyDecoder: allConverters.uint32,
  } as ServiceCallType<void, number>,

  putDataLogUploadPeriod: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/data-log/upload-period',
    path: '/1024//33',
    bodyEncoder: allConverters.uint32,
  } as ServiceCallType<number, void>,

  getMqttBrokerPort: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/mqtt/broker-port',
    path: '/1024//61',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putMqttBrokerPort: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/mqtt/broker-port',
    path: '/1024//61',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getMqttClientId: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/mqtt/client-id',
    path: '/1024//27',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putMqttClientId: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/mqtt/client-id',
    path: '/1024//27',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getMqttUsername: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/mqtt/username',
    path: '/1024//28',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putMqttUsername: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/mqtt/username',
    path: '/1024//28',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getMqttPassword: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/mqtt/password',
    path: '/1024//29',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putMqttPassword: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/mqtt/password',
    path: '/1024//29',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getDataLogPublishTopic: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/data-log/publish-topic',
    path: '/1024//68',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putDataLogPublishTopic: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/data-log/publish-topic',
    path: '/1024//68',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,

  getDataLogSubscribeTopic: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/cloud/data-log/subscribe-topic',
    path: '/1024//69',
    responseBodyDecoder: allConverters.ascii,
  } as ServiceCallType<void, string>,

  putDataLogSubscribeTopic: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/cloud/data-log/subscribe-topic',
    path: '/1024//69',
    bodyEncoder: allConverters.ascii,
  } as ServiceCallType<string, void>,
};
